'use strict';

var path = location.pathname.split('/');
var app = path[1];
if(path.length == 4) app = path[1] + "/" + path[2]; 
export const appPath = app;  
//While building the project for update to other server in production mode, you need to comment above and uncomment below with actual VD name
//export const appPath = "TestPlayer";   


// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/globals.ts